import schemas from 'components/forms/fields/definedSchemas';
import Joi from 'joi';

const fields = {
    nvic_name: {
        ...schemas.autocompleteSelectRequired,
        section: 'NVIC',
        label: 'What is the name of the NVIC?',
        validation: Joi.object().messages({
            'object.base': 'Please select an NVIC from the list.',
        }),
    },
    nvic_completed: {
        ...schemas.boolRequired,
        section: 'NVIC',
        label: 'Is this NVIC completed?',
    },
    completed_date: {
        ...schemas.dateRequiredMaxToday,
        section: 'NVIC',
        label: 'What day did you complete this NVIC?',
        validation: Joi.when('nvic_completed', {
            is: true,
            then: Joi.boolean().required().messages({
                'boolean.base': 'Please pick the date your NVIC was completed.',
            }),
            otherwise: Joi.string().allow('', null),
        }),
    },
    assessor_info_completed: {
        ...schemas.boolRequired,
        section: 'NVIC',
        label: 'Is all of the information about the Qualified Assessor(s) on the last page of this NVIC completed?',
        validation: Joi.when('nvic_completed', {
            is: true,
            then: schemas.boolRequired.validation,
            otherwise: Joi.string().allow('', null),
        }),
    },
};

export default fields;
